"use strict";
// COLORS
Object.defineProperty(exports, "__esModule", { value: true });
// old implementation
const brand = "#119CFD";
const headerBackgroundColor = "#FFFFFF";
const headerTextColor = brand;
const mainInfoLandscape = brand;
const mainInfoPortrait = brand;
const style = "normal";
// new implamentation
const colorAppBar = "#119CFD";
const colorOnAppBar = "#FFFFFF";
const colorPrimary = "#119CFD";
const colorPrimaryDarker = "#0277c9";
const colorPrimaryLighter = "#cfebff";
const colorOnPrimary = "#FFFFFF";
const colorSecondary = "#119CFD";
const colorOnSecondary = "#FFFFFF";
const colorTiles = ["#119CFD", "#119CFD", "#119CFD"];
exports.default = {
    brand,
    mainInfoLandscape,
    mainInfoPortrait,
    headerBackgroundColor,
    headerTextColor,
    style,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
